import { Radar } from "react-chartjs-2";
import { Card, CardBody, Col } from 'reactstrap'
import { ChatJSRadarGraph } from '../../../../Utils/Constants'
import { radarGraphChartData } from "../../../../Data/Charts/ChartJs/ChartJs";
import CommonCardHeader from "../../../../Utils/CommonComponents/CommonCardHeader/CommonCardHeader";

const RadarGraph = () => {
  return (
    <Col xl="6" ms="12" className="box-col-6">
      <Card>
        <CommonCardHeader title={ChatJSRadarGraph} />
        <CardBody className="chart-block">
          <Radar id="myRadarGraph" data={radarGraphChartData} options={radarGraphChartData.options} width={778} height={400} />
        </CardBody>
      </Card>
    </Col>
  )
}

export default RadarGraph